import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-text-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './edit-text-modal.component.html',
  styleUrl: './edit-text-modal.component.css'
})
export class EditTextModalComponent implements OnInit {
  @Input() heading!: string;
  @Input() text!: string;

  @Output() saveConfirmed = new EventEmitter<{ heading: string; text: string }>();

  editedHeading = '';
  editedText = '';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.editedHeading = this.heading || '';
    this.editedText = this.text || '';
  }

  onCancel(): void {
    this.activeModal.dismiss();
  }

  onSave(): void {
    this.saveConfirmed.emit({ heading: this.editedHeading.trim(), text: this.editedText.trim() });
  }
}


